import ListBullet from 'assets/format_list_bulleted.svg'
import { Menu, MenuItem, IconButton } from '@mui/material'
import { type GridRenderCellParams } from '@mui/x-data-grid'
import { useState } from 'react'
import { type BadgeReward } from 'types/api'
import { useSnackbar } from 'stores/useSnackbar'
import { useDeleteBadgeById } from 'hooks/api/Contests/BadgeReward/useDeleteBadgeById'
import { type ApiError } from 'openapi-typescript-fetch'

export const DeleteBadgeRenderCell = ({
  params,
}: {
  params: GridRenderCellParams<BadgeReward>
}) => {
  const [anchorEl, setAnchorEl] = useState<Element | null>(null)
  const setSnackbarMessage = useSnackbar((state) => state.setMessage)
  const handleMenuOpen = (event: React.SyntheticEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleMenuClose = () => {
    setAnchorEl(null)
  }

  const handleDelete = (id?: number | null) => {
    useDeleteBadgeMutation.mutate({ id })
  }

  const useDeleteBadgeMutation = useDeleteBadgeById({
    onSuccess: () => {
      setSnackbarMessage(`Badge successfully deleted`, 'success')
    },
    onError: (error: Error, _variables) => {
      const apiError = error as ApiError
      if (
        typeof apiError.data === 'string' &&
        apiError.data.includes('is a dependent')
      ) {
        setSnackbarMessage(apiError.data, 'error')
      } else {
        setSnackbarMessage(
          `An error has occured while deleting the Badge`,
          'error'
        )
      }
    },
  })

  return (
    <>
      <IconButton onClick={handleMenuOpen}>
        <img src={ListBullet} width={4} height={16} alt="options icon" />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        <MenuItem
          onClick={() => {
            handleMenuClose()
            handleDelete(params.row.id)
          }}
        >
          Delete Badge
        </MenuItem>
      </Menu>
    </>
  )
}
